import styled, { css } from 'styled-components';
import { Stack } from '@mui/material';
import { flex } from './Flex';

export const flexCenter = css`
  ${flex};
  justify-content: center;
  align-items: center;
`;

export const FlexCenter = styled(Stack).attrs({ direction: 'row' })`
  ${flexCenter};
`;
